import React,{ Component } from "react";
import { connect } from 'react-redux';
import Dispositions from "../Dispositions";
import {  DRAGGABLE_WINDOWS, API_ENDPOINTS } from '../../../constants';
import {   removeWindow} from '../../../redux/actions/A_draggable_windows_controller';
import { messageApiRequest } from "../../../redux/actions/A_messages_to_SM";
import { setDispositionData } from "../../../redux/actions/A_preview";

class RateRecord extends Component{
    constructor(props) {
        super(props);
        this.state = {
          ratedRecord: false,
          dispositionSelected: null,
          subDispositionSelected: null,
          FinishRecordPreview: false,
          showCanReprogram: false,
          reprogram: null,
          selectedRecord: this.props.selectedRecord,
          isActive: true,
        };
        this.data = {
          callId: "",
          reference: "",
          calloutId: ""
        };

      }
    
      componentWillReceiveProps(nextProps) {
        if (nextProps.selectedRecord.callId !== this.data.callId) {
          this.data = {callId: nextProps.selectedRecord.callId, calloutId: nextProps.selectedRecord.calloutId};
          this.setState({selectedRecord: nextProps.selectedRecord})
        }
      };

      saveDisposition(){
        let objectData = {
          CallId: this.state.selectedRecord.callId,
          DispositionId: this.state.dispositionSelected.Id,
          Origin: '',
          CallKey: this.state.selectedRecord.callKey,
          CallOutId: this.state.selectedRecord.callOutId,
          SubId: this.state.subDispositionSelected,
          CallType: 2,
          IsExitAssisted: this.state.dispositionSelected.FinishPreview,
          IsExitPreview: this.state.dispositionSelected.FinishRecordPreview,
        }
        setTimeout(()=>{
          this.props.messageApiRequest(API_ENDPOINTS.SAVE_DISPOSITION, objectData);
        },100)
        this.Rescheduled();
        setTimeout(()=>{
          this.onClose();
        },100)
      }

      Rescheduled(){
        if(this.state.dispositionSelected.CanReprogram || this.state.dispositionSelected.SubDisposition.CanReprogram){
          let objCallBack = {
            CamId: this.state.selectedRecord.camId,
            Phone: this.state.reprogram.phoneReprogram.selectionReschedule === 2 ? this.state.reprogram.phoneReprogram.otherPhone : this.state.reprogram.phoneReprogram.phone.number,
            TelReprograma:1, // type === 1 ? 1 : (reprogram.phoneReprogram.selectionReschedule === 2 ? 0 : reprogram.phoneReprogram.phone.id),
            IsAuto: false,
            DateDial: this.state.reprogram.dateReprogram
          }
          setTimeout(()=>{
            this.props.messageApiRequest(API_ENDPOINTS.CALL_BACK, objCallBack);
          },200)
        }
        if(this.state.dispositionSelected.FinishRecordPreview){
          this.props.setDispositionData({callOutId:this.state.selectedRecord.callOutId,alreadyRated:true,exitPreview:true});
        }
        else{
          this.props.setDispositionData({callOutId:this.state.selectedRecord.callOutId,alreadyRated:true,exitPreview:false});
        }
      };

      onClose() {
        this.props.removeWindow(DRAGGABLE_WINDOWS.RATE_RECORD);
        const rated = this.state.dispositionSelected != null ? true : false;
        this.setState({isActive: false, ratedRecord: rated});
        this.props.onCloseDispositionWindow(false);
        
      }

      setDisposition(disposition){
        this.setState({dispositionSelected: disposition.dispositionSelected, subDispositionSelected: disposition.subDispositionSelected});
      }

      setReprogram(repro){
        this.setState({reprogram: repro});
      }

      render() {
        const showSubDisposition = this.state.dispositionSelected != null && this.state.dispositionSelected.SubDisposition && this.state.dispositionSelected.SubDisposition.length > 0;
        
        return(
          <div className="rateContainer" onClick={() => this.props.goTopZ(this.props.id)}>
            <div className="rateRecordHeader" >
		          <i className='gcl-icon close' title='close' onClick={() => this.onClose()} />
            </div> 
            <Dispositions 
              type={1}
              endWraUpWithDisp={() => this.saveDisposition()}
              onChangeDisp={d => this.setDisposition(d)}
              onChangeReprogam={r => this.setReprogram(r)}
              rateInDialog={true}
            />
          </div> 
        );
      }
};

function mapStateToProps(state) {
    return {
        dragWindowController: state.dragWindowController,
        selectedRecord: state.preview.selectedRecord,
        simultaneosRecs : state.preview.simultaneosRecs,
        records : state.preview.records
    }
}
function mapDispatchToProps(dispatch) {
    return ({
        messageApiRequest: (subaction, json, expectsReponse) => {
			    dispatch(messageApiRequest(subaction, json, expectsReponse));
		    },
        removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
        setDispositionData:(data)=>{dispatch(setDispositionData(data))}
    })
}
export default RateRecord = connect(
    mapStateToProps,
    mapDispatchToProps
)(RateRecord);


// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/RateRecord.jsx